<template>
        <div class="row justify-content-center" :key="key">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <small>Loggen Sie sich mit Ihren Benutzerdaten ein</small>
                            <base-alert v-if="alert.message" :type="alert.type">{{alert.message}}</base-alert>
                        </div>
                        <form @submit="handleSubmit">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Benutzername/Email"
                                        addon-left-icon="ni ni-email-83"
                                        :disabled="isLoading"
                                        v-model.trim="model.email">
                            </base-input>

                            <div class="row">
                                <div class="col-10 pr-1">
                                    <fade-transition>
                                        <base-input class="input-group-alternative mr-0"
                                                                 placeholder="Password"
                                                                 :type="(!showPW) ? 'password' : 'text'"
                                                                 addon-left-icon="ni ni-lock-circle-open"
                                                                 :disabled="isLoading"
                                                                 v-model.trim="model.password"
                                        >
                                        </base-input>
                                    </fade-transition>
                                </div>
                                <div class="col-2 pl-0">
                                    <base-button :key="tick" block class="pl-2 pl-md-3" type="secondary" v-on:click="setShowPW" :icon="(!showPW) ? 'fas fa-eye' : 'fas fa-eye-slash'"></base-button>
                                </div>
                            </div>


                            <div class="text-center" >
                                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                                    <span class="btn-inner--icon" :key="key"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                    <span class="btn-inner--text">einloggen</span></button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <router-link to="/forgotpassword" class="btn btn-info btn-block">Passwort vergessen?</router-link>
                        <a href="https://config.socialguard.app/#/pid/3x90" class="btn btn-success btn-block" target="_blank">Geschäftskunde werden</a>
                        <button class="btn btn-icon btn-block my-4 btn-primary" @click="demologin">Demo</button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>


  import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
  export default {
    name: 'login',
      components:{FadeTransition},
      data() {
      return {
        model: {
            email: '',
            password: '',
            submitted: false
        },
          isLoading: false,
          key: 0,
          tick: 0,
          showPW: false
      }
    },
      computed: {
          loggingIn () {
              return this.$store.state.authentication.status.loggingIn;
          },
          alert () {
              return this.$store.state.alert
          }
      },
      created () {
          // reset login status
          this.$store.dispatch('authentication/logout');
      },
      methods: {
      demologin() {
        let email = process.env.VUE_APP_DEMOUSER
        let password = process.env.VUE_APP_DEMOPW
        this.isLoading = true;
        this.$store.dispatch('authentication/login', {email,password}).then(() =>{
              // eslint-disable-next-line no-console
              console.log("login");
              this.isLoading = false;
              this.key++;
            }
        ).catch(() => {
          this.isLoading = false;
          this.key++;
        });
      },
        setShowPW() {
            this.showPW = !this.showPW;
            this.tick++;
        },
          handleSubmit (e) {
              e.preventDefault();
              this.key++;
              this.submitted = true;
              let email = this.model.email;
              let password = this.model.password;
              const { dispatch } = this.$store;
              if (email && password) {
                  this.isLoading = true;
                  dispatch('authentication/login', {email,password}).then(() =>{
                      // eslint-disable-next-line no-console
                      console.log("login");
                      this.isLoading = false;
                      this.key++;
                    }
                  ).catch(() => {
                      this.isLoading = false;
                      this.key++;
                  });
              }
          }
      }
  }
</script>
<style>
</style>
